// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3mr2b","validationTips":"StatementDescriptor_validationTips__15NlW"};